import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import asyncThunks from '../async-thunks';
import { CustomerGroupSelectorState } from '../types';

const getData = (
  builder: ActionReducerMapBuilder<CustomerGroupSelectorState>,
) => {
  builder.addCase(
    asyncThunks.getData.pending,
    (state: CustomerGroupSelectorState) => {
      state.isLoading = true;
      state.isError = false;
    },
  );
  builder.addCase(
    asyncThunks.getData.fulfilled,
    (state: CustomerGroupSelectorState, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    },
  );
  builder.addCase(
    asyncThunks.getData.rejected,
    (state: CustomerGroupSelectorState) => {
      state.isLoading = false;
      state.isError = true;
    },
  );
};

export default getData;
